/* Tester only: validate choices before the theme's generic add-to-cart handler.
   This prevents accidental repeats in one tab; it is not a server-side limit. */
(function () {
  'use strict';
  if (window.digorTesterFormInstalled) return;
  window.digorTesterFormInstalled = true;
  let busy = false;

  function validate(fields) {
    const seen = new Set();
    const selects = Array.from(fields.querySelectorAll('select'));
    let valid = selects.length === 3;
    selects.forEach(function (select) {
      const duplicate = select.value !== '' && seen.has(select.value);
      const missing = select.value === '';
      select.setCustomValidity(duplicate ? 'Bitte wähle jeden Duft nur einmal.' : missing ? 'Bitte wähle drei Düfte.' : '');
      if (duplicate || missing) valid = false;
      if (select.value) seen.add(select.value);
    });
    return valid;
  }

  document.addEventListener('change', function (event) {
    const fields = event.target.closest('[data-tester-product]');
    if (fields) validate(fields);
  });

  document.addEventListener('submit', async function (event) {
    const form = event.target;
    const fields = form.querySelector('[data-tester-product]');
    if (!fields) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy) return;
    if (!validate(fields) || !form.checkValidity()) {
      form.reportValidity();
      return;
    }
    const status = fields.querySelector('[data-tester-status]');
    const button = form.querySelector('[name="add"]');
    function message(text) {
      status.textContent = text;
      status.hidden = false;
    }
    const variantInput = form.querySelector('[name="id"]');
    if (!variantInput || !fields.dataset.testerVariant) {
      message(fields.dataset.testerAvailable === 'false'
        ? 'Die Tester sind derzeit ausverkauft.'
        : 'Die Tester konnten nicht geladen werden. Bitte lade die Seite neu.');
      return;
    }
    variantInput.value = fields.dataset.testerVariant;
    busy = true;
    if (button) button.disabled = true;
    message('Deine Auswahl wird geprüft …');
    try {
      const response = await fetch(fields.dataset.cartUrl + '.js', {
        credentials: 'same-origin', cache: 'no-store'
      });
      if (!response.ok) throw new Error('cart unavailable');
      const cart = await response.json();
      if (!Array.isArray(cart.items)) throw new Error('invalid cart');
      if (cart.items.some(function (item) {
        return String(item.product_id) === fields.dataset.testerProduct;
      })) {
        message('Deine Tester sind bereits im Warenkorb. Entferne dort das bisherige Set, wenn du andere Düfte wählen möchtest.');
        return;
      }
      const body = new FormData(form);
      body.set('quantity', '1');
      const added = await fetch(fields.dataset.addUrl + '.js', {
        method: 'POST', credentials: 'same-origin', body: body
      });
      if (!added.ok) throw new Error('add failed');
      window.location.assign(fields.dataset.cartUrl);
    } catch (_error) {
      message('Die Auswahl konnte nicht bestätigt werden. Prüfe bitte deinen Warenkorb, bevor du es erneut versuchst.');
    } finally {
      busy = false;
      if (button) button.disabled = false;
    }
  }, true);
})();
